import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css'; // Import the CSS file for styling

const App = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [notes, setNotes] = useState('');
  const [customers, setCustomers] = useState([]);

  // Handle form submission for adding a new customer
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://customer-notes-worker.dgironda.workers.dev/add-customer', {
        name,
        email,
        notes,
      });
      alert('Customer added');
      fetchCustomers(); // Fetch updated customers
    } catch (error) {
      console.error('Error adding customer:', error);
    }
  };

  // Handle updating a customer
  const handleUpdate = async (email) => {
    const updatedNotes = prompt('Enter new notes:');
    if (updatedNotes) {
      try {
        await axios.put('https://customer-notes-worker.dgironda.workers.dev/update-customer', {
          email,
          notes: updatedNotes,
        });
        alert('Customer updated');
        fetchCustomers(); // Fetch updated customers
      } catch (error) {
        console.error('Error updating customer:', error);
      }
    }
  };

  // Fetch customer list from the Cloudflare Worker
  const fetchCustomers = async () => {
    try {
      const response = await axios.get('https://customer-notes-worker.dgironda.workers.dev/get-customers');
      setCustomers(response.data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  // Fetch customers on component mount
  useEffect(() => {
    fetchCustomers();
  }, []);

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>Customer Notes</h1>
      </header>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="customer-form">
          <input
            type="text"
            placeholder="Customer Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="form-input"
          />
          <input
            type="email"
            placeholder="Customer Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-input"
          />
          <textarea
            placeholder="Meeting Notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            className="form-textarea"
          />
          <button type="submit" className="submit-button">Add Customer</button>
        </form>
      </div>

      <div className="customer-list-container">
        <h2>Customer List</h2>
        <ul className="customer-list">
          {customers.map((customer, index) => (
            <li key={index} className="customer-item">
              <strong>{customer.name}</strong> ({customer.email}): {customer.notes}
              <button onClick={() => handleUpdate(customer.email)} className="edit-button">Edit</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default App;
